var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.803,
    height: 37.602,
    viewBox: "0 0 40.803 37.602",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    transform: "translate(0.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specialist---View-directory-profile-v2-_collapsed_",
    "data-name": "Specialist---View-directory-profile-v2-(collapsed)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "office-referral"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M2.967,11.2V27.427h9.078V15.26h9.078V27.427H30.2V11.2",
    transform: "translate(2.403 8.174)",
    fill: "none",
    stroke: "#69b100",
    strokeLinecap: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M0,19.6,18.987,0,37.975,19.6",
    fill: "none",
    stroke: "#69b100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    d: "M14.093.747h6.713v6.76",
    transform: "translate(10.656 0.605)",
    fill: "none",
    stroke: "#69b100",
    strokeLinecap: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.ce869821be4c8b3b3af1745ef31b91ab.svg";